import { useEffect } from "react";
import Hero from "@/components/sections/Hero";
import TrustedBy from "@/components/sections/TrustedBy";
import EnterprisePlatform from "@/components/sections/EnterprisePlatform";
import WhySpringXE from "@/components/sections/WhySpringXE";
import AIExperience from "@/components/sections/AIExperience";
import CapabilityDev from "@/components/sections/CapabilityDev";
import PlatformFeatures from "@/components/sections/PlatformFeatures";
import LearningJourney from "@/components/sections/LearningJourney";
import SuccessMetrics from "@/components/sections/SuccessMetrics";
import Testimonials from "@/components/sections/Testimonials";
import Industries from "@/components/sections/Industries";
import TechPartners from "@/components/sections/TechPartners";
import FAQSection from "@/components/sections/FAQSection";

const DUNS_SRC = "https://dunsregistered.dnb.com";
const DUNS_ID = "duns-registered-seal";

// Injects the D&B D-U-N-S® Registered™ seal script — Home page ONLY, async, deduped.
const useDunsSeal = () => {
    useEffect(() => {
        if (document.getElementById(DUNS_ID)) return undefined;
        const s = document.createElement("script");
        s.id = DUNS_ID;
        s.src = DUNS_SRC;
        s.type = "text/javascript";
        s.async = true;
        document.body.appendChild(s);
        return () => {
            // Leave the injected DOM alone on unmount so the seal stays if user returns to Home,
            // but remove the tag so re-mount injections stay clean if the seal wasn't rendered.
            const el = document.getElementById(DUNS_ID);
            if (el && el.parentNode) el.parentNode.removeChild(el);
        };
    }, []);
};

const Home = ({ openCatalogue }) => {
    useDunsSeal();
    return (
        <div data-testid="home-page">
            <Hero onOpenCatalogue={openCatalogue} />
            <TrustedBy />
            <EnterprisePlatform />
            <WhySpringXE />
            <AIExperience />
            <CapabilityDev />
            <PlatformFeatures />
            <LearningJourney />
            <SuccessMetrics />
            <Testimonials />
            <Industries />
            <TechPartners />
            <FAQSection />
        </div>
    );
};

export default Home;
